<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/teSEDR/tc-custom/9781497634268.jpg?1732966806308" alt="This image is the cover for the book Mind Over Golf"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mind Over Golf
      </h1>
      <p class="bookDescription body article font2">
        <p>There’s an interesting point at which the psychological and technical sides of golf meet--and Tom Nieporte and Don Sauers discover this by talking with America’s leading golf professionals. The tips provided in this book will help golfers of any level discover or regain confidence that will drop strokes off of every golfer’s score. Any golfer must know how to master the eight major golfing skills, and from this book golfers will learn how easy it is to turn handicapping weaknesses into winning strengths. The most valuable advice here is sure to cultivate winners on the green!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Sauers, Tom Nieporte
      </h2>
      
      <p class="authorDescription body article">Don Sauers is a free-lance writer, retired advertising executive and amateur golfer. His books on a variety of subjects have been published by Doubleday and Harper.Tom Nieporte is a widely respected teacher and master of the mental game. He is Head Pro at Winged Foot Golf Club, site of numerous national championships including the 1984 U.S. Open and the 1998 PGA Championship. Previously Tom was a regular on the PGA tour, winning three times including the 1967 Bob Hope Desert Classic when he defeated Doug Sanders by one stroke. He also competed in 13 U.S. Opens and 13 PGA Championships.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79856dd4